export const BACKEND_URL =
  process.env.BACKEND_URL ||
  "https://rd9y38bh7e.execute-api.us-east-1.amazonaws.com/Prod";
